import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useRouter } from "next/router";
import ProductsCompareTable from "@components/ProductsCompareTable/ProductsCompareTable";

import { getCompareDataApi } from "@lib/api";
import { makeApiCall } from "@lib/api/helpers";
import { addAlert } from "@store/app/actions";
import Loading from "@components/Loading";

const ProductCompareSection = ({ product }) => {
  const [compareData, setCompareData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    const loadCompareData = async () => {
      const currentSku = product.sku;

      if (compareData) {
        setIsLoading(false);
      } else {
        const response = await makeApiCall({
          apiCall: getCompareDataApi,
          apiArgs: [currentSku],
          formatResponse: (response) => {
            return {
              products: response.data.products,
              attributes: response.data.products[0]?.info?.groups || [],
            };
          },
          preFail: () =>
            addAlert({
              message: "Nu am putut prelua datele.",
              variant: "error",
            }),
        });

        if (response) {
          setCompareData(response);
        }
        setIsLoading(false);
      }
    };

    loadCompareData();
  }, [product]);

  const handleProductClick = (product) => {
    if (product && product.url_key && product.sku) {
      router.push(`/${product.url_key}/cpd/${product.sku}/`);
    }
  };

  if (isLoading) {
    return <Loading height={100} />;
  }

  if (compareData === null) {
    return (
      <div className="p-4 text-center text-gray-600">
        Nici un produs disponibil pentru comparatie.
      </div>
    );
  }

  return (
    <ProductsCompareTable
      products={compareData.products}
      productsAttributeGroups={compareData.attributes}
      onProductClick={handleProductClick}
      canRemove={false}
    />
  );
};

export default connect((state) => ({
  currentProduct: state.catalog.currentProduct,
}))(ProductCompareSection);
